t<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <CalculatorHeading :step="step"></CalculatorHeading>
      <CountImageInput
        :question="$t('displays.question')"
        :counter.sync="displays"
        :image="require('@/assets/' + displayImg)"
      >
      </CountImageInput>
      <one-button type="primary" class="next-btn" @click.native="next()">
        {{ $t('next') }}
      </one-button>
      <a @click="$router.push(getPrevStepUrl(step, $i18n.locale))" class="back-btn"
        >{{ $t('back') }}</a
      >
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import CountImageInput from "../../components/CountImageInput";
import CalculatorHeading from "../../components/CalculatorHeading";
import {
  getStepIndex,
  redirectToUnselectedStepIfAny,
  getPrevStepUrl,
  getNextStepUrl
} from "@/utils/steps.js";

export default {
  name: "Displays",
  components: { CalculatorHeading, CountImageInput },
  data() {
    return {
      step: getStepIndex("displays"),
      getPrevStepUrl: getPrevStepUrl,
      displays: this.$store.state.data.displays,
      displayImg:
        this.$store.state.data.mobileApp === "android"
          ? "display-knx.png"
          : "display-ios.jpg"
    };
  },
  watch: {
    displays: function() {
      this.updateDisplays(this.displays);
    }
  },
  mounted() {
    redirectToUnselectedStepIfAny(
      this.step,
      this.$store.state.data,
      this.$router,
      this.$i18n.locale
    );
  },
  methods: {
    ...mapMutations(["updateDisplays"]),
    next() {
      setTimeout(() => this.$router.push(getNextStepUrl(this.step, this.$i18n.locale)), 200);
    }
  }
};
</script>

<style scoped>
.calculator {
  align-items: center;
}
</style>
